const LOAD_ACR_QUERIES = {
  BEGIN: "LOAD_ACR_QUERIES_BEGIN",
  SUCCESS: "LOAD_ACR_QUERIES_SUCCESS",
  FAILURE: "LOAD_ACR_QUERIES_FAILURE"
};

const ADD_NEW_ACR_QUERY = {
  BEGIN: "ADD_NEW_ACR_QUERY_BEGIN",
  SUCCESS: "ADD_NEW_ACR_QUERY_SUCCESS",
  FAILURE: "ADD_NEW_ACR_QUERY_FAILURE"
};

const UPDATE_ACR_QUERY = {
  BEGIN: "UPDATE_ACR_QUERY_BEGIN",
  SUCCESS: "UPDATE_ACR_QUERY_SUCCESS",
  FAILURE: "UPDATE_ACR_QUERY_FAILURE"
};

const DELETE_ACR_QUERY = {
  BEGIN: "DELETE_ACR_QUERY_BEGIN",
  SUCCESS: "DELETE_ACR_QUERY_SUCCESS",
  FAILURE: "DELETE_ACR_QUERY_FAILURE"
};

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ACR_QUERIES.SUCCESS:
      let { queries } = action.payload;
      queries = queries.reduce((acc, q) => {
        acc[q.name] = q;
        return acc;
      }, {});
      return { ...state, ...queries };
    case UPDATE_ACR_QUERY.SUCCESS:
    case ADD_NEW_ACR_QUERY.SUCCESS:
      let acrQuery = action.payload;
      return { ...state, [acrQuery.name]: acrQuery };
    case DELETE_ACR_QUERY.SUCCESS:
      let acrQueryName = action.payload;
      delete state[acrQueryName];

      return { ...state };
    default:
      return state;
  }
}

export const loadAcrQueries = query => {
  return {
    types: [
      LOAD_ACR_QUERIES.BEGIN,
      LOAD_ACR_QUERIES.SUCCESS,
      LOAD_ACR_QUERIES.FAILURE
    ],
    api: api => api.getAcrQueries(query)
  };
};

export const addNewAcrQuery = body => {
  return {
    types: [
      ADD_NEW_ACR_QUERY.BEGIN,
      ADD_NEW_ACR_QUERY.SUCCESS,
      ADD_NEW_ACR_QUERY.FAILURE
    ],
    api: api => api.addAcrQuery(body)
  };
};

export const updateAcrQuery = (id, body) => {
  return {
    types: [
      UPDATE_ACR_QUERY.BEGIN,
      UPDATE_ACR_QUERY.SUCCESS,
      UPDATE_ACR_QUERY.FAILURE
    ],
    api: api => api.updateAcrQuery(id, body)
  };
};

export const deleteAcrQuery = id => {
  return {
    types: [
      DELETE_ACR_QUERY.BEGIN,
      DELETE_ACR_QUERY.SUCCESS,
      DELETE_ACR_QUERY.FAILURE
    ],
    api: api => api.deleteAcrQuery(id)
  };
};
